import { Ajax2 } from '@shared/Ajax';

export interface ExportJob {
    startedAt: number;
    jobUuid: string;
}

export interface ExportStatus {
    finishedAt: number | null;
    startedAt: number | null;
    jobUuid: string;
    resultObjectKey: string | null;
    stage: string;
    totalImages: number | null;
    annotatedImages: number | null;
}

async function startExport(selectedImages?: string[]): Promise<ExportJob | null> {
    if (selectedImages) {
        const resp = await Ajax2({
            url: kuura.AwsApiGatewayDomain() + '/metamarker/v1/export-selected?project_uuid=' + kuura.getProjectUuid(),
            method: 'POST',
            useToken: true,
            data: selectedImages,
            contentType: 'json',
        });

        if (resp.startedAt && resp.jobUuid) {
            return resp as ExportJob;
        }
    }

    const resp = await Ajax2({
        url: kuura.AwsApiGatewayDomain() + '/metamarker/v1/export?project_uuid=' + kuura.getProjectUuid(),
        method: 'GET',
        useToken: true,
    });

    if (resp.startedAt && resp.jobUuid) {
        return resp as ExportJob;
    }

    return null;
}

async function getStatusForExportJob(job: ExportJob): Promise<ExportStatus | null> {
    try {
        const resp = await Ajax2({
            url: kuura.AwsApiGatewayDomain() + '/metamarker/v1/export/status?project_uuid=' + kuura.getProjectUuid() + '&job_uuid=' + job.jobUuid,
            method: 'GET',
            useToken: true,
        });

        return resp as ExportStatus;
    } catch (error: unknown) {
        if (error instanceof Error) {
            console.error('Failed to get export status for job', error.message);
        }

        return null;
    }
}

async function getLatestStatusForProject(projectUuid: string): Promise<ExportStatus | null> {
    try {
        const resp = await Ajax2({
            url: kuura.AwsApiGatewayDomain() + '/metamarker/v1/export/status/latest?project_uuid=' + projectUuid,
            method: 'GET',
            useToken: true,
        });

        return resp;
    } catch (error: unknown) {
        if (error instanceof Error) {
            console.error('Failed to get latest export status for project', error.message);
        }

        return null;
    }
}

export const PixelPackerService = {
    startExport,
    getStatusForExportJob,
    getLatestStatusForProject,
};
